import intToReal from '@helpers/intToReal';
import stringToSlug from '@helpers/stringToSlug';

class ProductDomain {
  constructor (data) {
    data = data || {}

    this.name = data.name || null
    this.lottery = data.lottery || null
    this.badge = data.badge || null
    this.moreChances = data.moreChances || 0
    this.items = data.items || []
    this.units = data.units || 0
    this.unitPrice = data.unitPrice || 0
    this.unitPriceText = intToReal(this.unitPrice)
    this.badgeSlug = this.badge ? stringToSlug(this.badge) : null
  }
}

export default ProductDomain
